import {
  ChangeDetectorRef,
  Directive,
  Inject,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ComponentStore } from '@ngrx/component-store';
import { from, Observable, take, tap } from 'rxjs';
import { RgpdPromptComponent } from './rgpd-prompt.component';
import { TranslocoService } from '@ngneat/transloco';

const promptComponent = import('./rgpd-prompt.component').then(
  (it) => it.RgpdPromptComponent
);

@Directive({
  selector: '[i2lRgpdPrompt]',
  standalone: true,
})
export class RgpdPromptDirective extends ComponentStore<{
  accepted: boolean;
  title?: string;
  message?: string;
}> {
  hasView = false;

  accepted$ = this.select((s) => s.accepted);

  @Input() set i2lRgpdPrompt(accepted: boolean | undefined) {
    if (typeof accepted === 'boolean') {
      this.patchState({ accepted });
    }
  }

  @Input() set i2lRgpdPromptTitle(title: string | undefined) {
    if (title) {
      this.patchState({ title });
    }
  }

  @Input() set i2lRgpdPromptMessage(message: string | undefined) {
    if (message) {
      this.patchState({ message });
    }
  }

  @Input() i2lRgpdPromptBackgroundUrl: string | undefined;

  setAccepted = this.effect((accepted$: Observable<boolean>) => {
    return accepted$.pipe(
      tap((accepted) => {
        this.viewContainer.clear();
        if (accepted && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else if (!accepted) {
          from(promptComponent)
            .pipe(take(1))
            .subscribe((promptCmp) => {
              const componentRef =
                this.viewContainer.createComponent<RgpdPromptComponent>(
                  promptCmp
                );
              componentRef.setInput(
                'backgroundUrl',
                this.i2lRgpdPromptBackgroundUrl
              );
              componentRef.setInput(
                'title',
                this.get((s) => s.title)
              );
              componentRef.setInput(
                'message',
                this.get((s) => s.message)
              );
              componentRef.changeDetectorRef.detectChanges();
            });
        }
      })
    );
  });

  constructor(
    @Inject(DOCUMENT)
    private document: Document,
    private viewContainer: ViewContainerRef,
    private cdr: ChangeDetectorRef,
    private templateRef: TemplateRef<any>,
    private transloco: TranslocoService
  ) {
    super({ accepted: false });
    this.setAccepted(this.accepted$);
  }
}
